import { render, staticRenderFns } from "./BuildYourShop.vue?vue&type=template&id=3ed65d5d"
import script from "./BuildYourShop.vue?vue&type=script&lang=js"
export * from "./BuildYourShop.vue?vue&type=script&lang=js"
import style0 from "./BuildYourShop.vue?vue&type=style&index=0&id=3ed65d5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports